import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="nifty-UI-guide" transform="translate(-341.000000, -2927.000000)" fill={color} fillRule="nonzero">
                <g id="Group-6-Copy" transform="translate(298.000000, 2884.000000)">
                    <path d="M78.3409903,46.8409903 L64.1819805,61 L78.3409903,75.1590097 C79.2196699,76.0376894 79.2196699,77.4623106 78.3409903,78.3409903 C77.4623106,79.2196699 76.0376894,79.2196699 75.1590097,78.3409903 L59.4090097,62.5909903 C58.5303301,61.7123106 58.5303301,60.2876894 59.4090097,59.4090097 L75.1590097,43.6590097 C76.0376894,42.7803301 77.4623106,42.7803301 78.3409903,43.6590097 C79.2196699,44.5376894 79.2196699,45.9623106 78.3409903,46.8409903 Z M59.2159903,50.2159903 L48.4319805,61 L59.2159903,71.7840097 C60.0946699,72.6626894 60.0946699,74.0873106 59.2159903,74.9659903 C58.3373106,75.8446699 56.9126894,75.8446699 56.0340097,74.9659903 L43.6590097,62.5909903 C42.7803301,61.7123106 42.7803301,60.2876894 43.6590097,59.4090097 L56.0340097,47.0340097 C56.9126894,46.1553301 58.3373106,46.1553301 59.2159903,47.0340097 C60.0946699,47.9126894 60.0946699,49.3373106 59.2159903,50.2159903 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconArrowsLeft extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
